var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-col",
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                {
                  staticStyle: {
                    "text-overflow": "ellipsis",
                    overflow: "hidden",
                    "white-space": "nowrap",
                    "font-size": "14px",
                  },
                  attrs: { span: 8 },
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("panel.who_share") +
                          ": " +
                          _vm.$store.getters.user.nickName
                      )
                    ),
                  ]),
                ]
              ),
              _c(
                "el-col",
                {
                  staticStyle: {
                    "text-overflow": "ellipsis",
                    overflow: "hidden",
                    "white-space": "nowrap",
                    "font-size": "14px",
                  },
                  attrs: { span: 8 },
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("panel.when_share") +
                          ": " +
                          (_vm.granterTime
                            ? new Date(_vm.granterTime).format(
                                "yyyy-MM-dd hh:mm:ss"
                              )
                            : "")
                      )
                    ),
                  ]),
                ]
              ),
              _c("el-col", {
                staticStyle: {
                  "text-overflow": "ellipsis",
                  overflow: "hidden",
                  "white-space": "nowrap",
                  "font-size": "14px",
                },
                attrs: { span: 8 },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { display: "flex" } },
            [
              _c(
                "el-col",
                {
                  staticStyle: {
                    "text-overflow": "ellipsis",
                    overflow: "hidden",
                    "white-space": "nowrap",
                    "font-size": "14px",
                    width: "90px",
                  },
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("panel.share_to")))])]
              ),
              _c(
                "el-col",
                [
                  _vm._l(_vm.dynamicTags, function (tag) {
                    return _c(
                      "el-tag",
                      {
                        key: tag.targetName,
                        staticClass: "selected-tag",
                        attrs: {
                          type: tag.tagType,
                          size: "small",
                          closable: "",
                          "disable-transitions": false,
                        },
                        on: {
                          close: function ($event) {
                            return _vm.handleClose(tag)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(tag.targetName) + "\n        "
                        ),
                      ]
                    )
                  }),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "dark",
                        content: _vm.$t("commons.edit"),
                        placement: "bottom",
                      },
                    },
                    [
                      _c("el-button", {
                        staticClass: "button-new-tag",
                        attrs: {
                          type: "primary",
                          circle: "",
                          icon: "el-icon-edit",
                          size: "mini",
                        },
                        on: { click: _vm.showEditPage },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _c("el-row"),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          staticClass: "dialog-css",
          attrs: {
            title: _vm.authTitle,
            visible: _vm.authVisible,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.authVisible = $event
            },
          },
        },
        [
          _vm.authVisible
            ? _c("grant-auth", {
                attrs: { "resource-id": _vm.authResourceId },
                on: { "close-grant": _vm.closeGrant },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }